module.exports = __webpack_public_path__ + "static/img/ai_content2.0374701.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/h5/matrix/ai_content2.png
// module id = 9gEd
// module chunks = 34